/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useRef } from 'react';
import Slider from 'react-slick';
import '../styles/PhotoGallery.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const photos = Array.from({ length: 31 }, (_, i) => `/image/${i + 1}.jpg`);

const PhotoGallery = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const mainSliderRef = useRef(null);
  const thumbnailSliderRef = useRef(null);

  const settings = {
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    beforeChange: (_, next) => setSelectedIndex(next),
    ref: mainSliderRef,
  };

  const thumbnailSettings = {
    slidesToShow: 10,
    swipeToSlide: true,
    focusOnSelect: true,
    arrows: false,
    infinite: false,
    ref: thumbnailSliderRef,
    afterChange: (index) => {
      setSelectedIndex(index);
    },
  };

  // Function to go to selected index in main slider
  const goToSlide = (index) => {
    setSelectedIndex(index);
    mainSliderRef.current?.slickGoTo(index);
  };

  return (
    <section className="photo-gallery">
      <h2 className="gallery-title">Photo Gallery</h2>

      <Slider {...settings} className="main-photo-slider" ref={mainSliderRef}>
        {photos.map((src, index) => (
          <div key={index} className="main-photo-container">
            <img
              src={src}
              alt={`Gallery Image ${index + 1}`}
              className="main-photo"
            />
          </div>
        ))}
      </Slider>

      <Slider {...thumbnailSettings} className="thumbnail-slider" ref={thumbnailSliderRef}>
        {photos.map((src, index) => (
          <div key={index} onClick={() => goToSlide(index)}>
            <img
              src={src}
              alt={`Thumbnail ${index + 1}`}
              className={`thumbnail ${index === selectedIndex ? 'active' : ''}`}
              loading="lazy"
            />
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default PhotoGallery;
